import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';
import { CustomerStatus } from 'src/app/shared/store-mocks/status.store';
import { map } from 'rxjs/operators';
import { AdvancedFiltersFormWhatsappStatusStore } from './advanced-filters-form-whatsapp-status.store';

@Component({
  selector: 'app-advanced-filters-form-whatsapp-status',
  templateUrl: './advanced-filters-form-whatsapp-status.component.html',
  styleUrls: ['./advanced-filters-form-whatsapp-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AdvancedFiltersFormWhatsappStatusStore]
})
export class AdvancedFiltersFormWhatsappStatusComponent implements OnInit {

  onChange: any = () => {}
  onTouch: any = () => {}


  
  statusCurrentValue$ = this.store.statusValue$.pipe(map(
    (value) => {
      return value.length ? value.split(',').filter(s => s !== CustomerStatus.NONE) : []
    }
  ))
  statusEntities$ = this.store.entities$

  constructor(
    public ngControl: NgControl,
    private store: AdvancedFiltersFormWhatsappStatusStore

    ) {
      ngControl.valueAccessor = this;
    }

  ngOnInit(): void {}

  writeValue(value: string){}

  registerOnChange(fn: any){
    this.onChange = fn
  }

  registerOnTouched(fn: any){
    this.onTouch = fn
  }

  statusValueChange(option: string[]) {
    this.saveValue(option.join(','))
  }


  saveValue(value){
    this.onChange(value)
    if(this.ngControl.untouched){
      this.onTouch()
    }
  }

  ngOnDestroy(){
    this.saveValue('')
  }
}
